import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import Report from '../../../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMeasurementsDailyEvolutionSelectors';

export class DespatchMeasurementsDailyEvolutionContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChart: false,
      chartMeta: {},
    };
  }

  setChartMeta = (chartMeta) => {
    this.setState({
      chartMeta,
      showChart: true,
    });
  };

  closeChart = () => {
    this.setState({
      showChart: false,
    });
  };

  render() {
    return (
      <Report
        reportId={ReportDefinitions.DESPATCH_MEASUREMENTS_DAILY_EVOLUTION.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.columns(this.setChartMeta)}
        showChart={this.state.showChart}
        chartMeta={this.state.chartMeta}
        closeChart={this.closeChart}
        className="despatchMeasurementsDailyEvolutionReport"
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
  };
}

DespatchMeasurementsDailyEvolutionContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.func,
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchMeasurementsDailyEvolutionContainer);
